/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fertilizer_Quarantine_PeriodInputs */

const vi_fertilizer_quarantine_period = /** @type {(inputs: Fertilizer_Quarantine_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thời gian cách ly`)
};

/**

* @param {Fertilizer_Quarantine_PeriodInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const fertilizer_quarantine_period = /** @type {((inputs?: Fertilizer_Quarantine_PeriodInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fertilizer_Quarantine_PeriodInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_fertilizer_quarantine_period(inputs)
});